import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { ConstantsGuard, TranslationsGuard } from '@ui/legacy-lib';

import { CustomerSettingsGuard } from 'landlord/guards';
import { ImportSettingsGuard } from 'landlord/guards/import-settings.guard';
import { CustomerCooperationGuard } from 'landlord/guards/customer-cooperation.guard';
import { UserPermission } from '@ui/shared/models';
import { AuthGuard, canActivateWithPermission } from './auth';
import { InternalListEffects, reducer } from './main/+state/internal-list';

import { ROUTES as LandingRoutes } from './screens/landings';
import { ROUTES as AccountRoutes, UserDataGuard } from './screens/account';
import { ROUTES as MainRoutes } from './main';

import * as Layouts from './layouts';
import { ImpersonateComponent } from './auth/impersonate/impersonate.component';

export const ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard'
  },
  {
    path: 'impersonate',
    component: ImpersonateComponent
  },
  {
    path: '',
    canActivate: [TranslationsGuard],
    component: Layouts.FullscreenNotAuthenticatedComponent,
    children: [
      ...LandingRoutes,
      {
        path: 'static',
        loadChildren: () =>
          import('landlord/screens/static-content/static-content.module').then(
            module => module.StaticContentModule
          )
      }
    ]
  },
  {
    path: '',
    component: Layouts.FullscreenAuthenticatedComponent,
    canActivate: [
      TranslationsGuard,
      AuthGuard,
      UserDataGuard,
      CustomerSettingsGuard,
      ImportSettingsGuard,
      ConstantsGuard,
      CustomerCooperationGuard
    ],
    children: [
      ...AccountRoutes,
      ...MainRoutes,
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/dashboard'
      },
      {
        path: 'aux',
        outlet: 'side',
        loadChildren: () =>
          import('landlord/auxiliary/auxiliary.module').then(
            module => module.AuxiliaryModule
          ),
        data: { animation: 'Auxiliary' },
        providers: [
          provideState('internal-list', reducer),
          provideEffects(InternalListEffects)
        ]
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('landlord/screens/reporting/reporting.module').then(
            module => module.ReportingModule
          ),
        data: {
          title: 'PAGE_DASHBOARD'
        },
        canActivate: [
          canActivateWithPermission({
            permissions: [UserPermission.REPORTING]
          })
        ]
      },
      {
        path: 'insufficient-permission',
        loadComponent: () =>
          import(
            'landlord/components/insufficient-permissions/insufficient-permissions.component'
          ).then(cmp => cmp.InsufficientPermissionsComponent)
      },
      {
        path: '**',
        redirectTo: '/dashboard'
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {
      scrollPositionRestoration: 'enabled',
      bindToComponentInputs: true
    })
  ],
  exports: [RouterModule]
})
export class AppRouterModule {}
